import { message } from "antd";
import { REVIEW } from "../constants/url";
import { genericApiCall, getApiCall } from "../utils/servicesBaseUtil";
import { catchErrors } from "../utils/catchErrors";

export const submitReviewApi = ({
  data,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return (dispatch) => {
    let url = REVIEW;

    genericApiCall({
      url: url,
      method: "POST",
      data: JSON.stringify(data),
      ContentType: "application/json",
    })
      .then((responseJson) => {
        if (responseJson?.success) {
          message.success(responseJson?.message);
          successCallback(responseJson);
        } else {
          message.error(responseJson?.message);
          failureCallback(responseJson?.data);
        }
      })
      .catch((error) => {
        catchErrors(error, url);
      })
      .finally(() => {
        finalCallback();
      });
  };
};

export const getSubmitReviewApi = ({
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return (dispatch) => {
    let url = REVIEW;

    getApiCall({ url: url })
      .then((responseJson) => {
        if (responseJson?.success) {
          successCallback(responseJson?.data);
        } else {
          failureCallback(responseJson?.data);
        }
      })
      .catch((error) => {
        catchErrors(error, url);
      })
      .finally(() => {
        finalCallback();
      });
  };
};
